import { render, staticRenderFns } from "./notification-history.vue?vue&type=template&id=71dff1c1"
import script from "./notification-history.vue?vue&type=script&lang=js"
export * from "./notification-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports